module.exports = __webpack_public_path__ + "img/05.partial-cloudy-light.cc4a53e5.svg";